// PDF exporter built on jsPDF + autotable. Renders a branded header bar, an
// optional summary block and a single data table. Generic enough for every
// report tab.
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export interface PdfOptions {
    title: string;
    /** e.g. business name + period. */
    subtitle?: string;
    /** Hex brand color for the header bar / table head. Falls back to purple. */
    brandColor?: string | null;
    columns: string[];
    rows: (string | number)[][];
    /** Optional totals shown above the table. */
    summary?: { label: string; value: string }[];
    filename: string;
}

const hexToRgb = (hex: string): [number, number, number] => {
    const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.trim());
    if (!m) return [108, 76, 240];
    return [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)];
};

export function exportPdf(o: PdfOptions): void {
    const doc = new jsPDF();
    const pageW = doc.internal.pageSize.getWidth();
    const [r, g, b] = hexToRgb(o.brandColor || '#6c4cf0');

    // Branded header bar.
    doc.setFillColor(r, g, b);
    doc.rect(0, 0, pageW, 20, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(14);
    doc.text(o.title, 14, 13);

    let y = 30;
    doc.setTextColor(90, 90, 90);
    doc.setFontSize(10);
    if (o.subtitle) {
        doc.text(o.subtitle, 14, y);
        y += 7;
    }
    if (o.summary && o.summary.length) {
        doc.setFontSize(9);
        o.summary.forEach((s) => {
            doc.text(`${s.label}: ${s.value}`, 14, y);
            y += 5;
        });
        y += 2;
    }

    autoTable(doc, {
        startY: y,
        head: [o.columns],
        body: o.rows,
        styles: { fontSize: 9, cellPadding: 2 },
        headStyles: { fillColor: [r, g, b], textColor: 255 },
        alternateRowStyles: { fillColor: [245, 245, 248] },
        margin: { left: 14, right: 14 },
    });

    doc.save(o.filename.endsWith('.pdf') ? o.filename : `${o.filename}.pdf`);
}
